var exports = {
  "h": "DesktopNotificationNagbar.module__description___Y2hFQn",
};

module.exports = exports;
